import { createRouter, createWebHistory } from "vue-router";
import store from "../store";

store.commit("onStart");

// Lazy loading components to improve performance
const AdminMain = () => import("../views/admin/AdminMain.vue");
const SalesMain = () => import("@/views/sales/SalesMain.vue");
const BrandingMain = () => import("@/views/branding/BrandingMain.vue");
const ServiceMain = () => import("@/views/customerService/CustomerServiceMain.vue");
const ServiceGuarantees = () => import("@/views/customerService/Guarantees.vue");
const Home = () => import("../views/Home.vue");
const DiscountCode = () => import("../components/discount/DiscountCode.vue");
const Products = () => import("../components/shared/Products.vue");
const Users = () => import("../components/shared/Users.vue");
const Orders = () => import("../components/orders/Orders.vue");
const CombinedStatistics = () => import("../components/shared/CombinedStatistics.vue");
const Login = () => import("../views/login.vue");
const Guarantees = () => import("../components/guarantees/Guarantees.vue");
const CreateJobPosition = () => import("../views/admin/CreateJobPosition.vue");
const Sms = () => import("../views/branding/PanelSms.vue");
const PanelSmsSales = () => import("@/views/sales/PanelSmsSales.vue");
const Representatives = () => import("@/components/shared/Representatives.vue");
const UsersAdmin = () => import("@/views/admin/createUsers.vue");
const ConnectingSn = () => import("@/views/warehouse/ConnectingSn.vue");
const WarehouseMain = () => import("@/views/warehouse/WarehouseMain.vue");
const OrderStatus = () => import("@/components/orders/OrderStatus.vue");
const Sn = () => import("@/components/shared/Sn.vue")

// Helper function to create order routes
const orderRoutes = [
    { path: ":status", component: OrderStatus },
];

const routes = [
    { path: "/login", name: "login", component: Login, meta: { logInRedirect: true } },
    {
        path: "/admin",
        component: AdminMain,
        meta: { logInRequired: true, role: "admin" },
        children: [
            { path: "", component: Home },
            { path: "combined_statistics", component: CombinedStatistics },
            { path: "orders", component: Orders, children: orderRoutes },
            { path: "DiscountCode", component: DiscountCode },
            { path: "products", component: Products },
            { path: "users", component: Users },
            { path: "guarantees", component: Guarantees },
            { path: "create-job-position", component: CreateJobPosition },
            { path: "sms", component: Sms },
            { path: "representatives", component: Representatives },
            { path: "users_admin", component: UsersAdmin },
            { path: "sn", component: Sn },
        ],
    },
    {
        path: "/sales",
        component: SalesMain,
        meta: { logInRequired: true, role: "sales" },
        children: [
            { path: "", component: Home },
            { path: "combined_statistics", component: CombinedStatistics },
            { path: "orders", component: Orders, children: orderRoutes },
            { path: "DiscountCode", component: DiscountCode },
            { path: "products", component: Products },
            { path: "users", component: Users },
            { path: "guarantees", component: Guarantees },
            { path: "panel-sms", component: PanelSmsSales },
            { path: "representatives", component: Representatives },
            { path: "sn", component: Sn },
        ],
    },
    {
        path: "/branding",
        component: BrandingMain,
        meta: { logInRequired: true, role: "branding" },
        children: [
            { path: "", component: Home },
            { path: "create-job-position", component: CreateJobPosition },
            { path: "sms", component: Sms },
        ],
    },
    {
        path: "/after-sales-service",
        component: ServiceMain,
        meta: { logInRequired: true, role: "after-sales-service" },
        children: [
            { path: "", component: Home },
            { path: "guarantees", component: ServiceGuarantees },
        ],
    },
    {
        path: "/warehouse-keeper",
        component: WarehouseMain,
        meta: { logInRequired: true, role: "warehouse-keeper" },
        children: [
            // { path: "", component: ConnectingSn },
            { path: "", component: Sn },
        ],
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior() {
        return { top: 0, behavior: "smooth" };
    },
});

router.beforeEach((to) => {
    if (to.meta.logInRequired && !store.state.isAuthentic) {
        return { path: "/login", query: { redirect: to.fullPath } };
    }
    if (to.meta.role !== store.state.role && to.path !== "/login") {
        return { path: "/login", query: { redirect: to.fullPath } };
    }
});

export default router;
